/* @flow */
import * as React from 'react';

import { Box, Button } from '@sonyged/proc-ui';
import css from '@styled-system/css';
import styled from 'styled-components';

import { Pizza } from '../../../pizza/fields/domain/pizza';
import AutoScaleContainer from '../../../pizza/fields/AutoScaleContainer';
import PizzaContainer from '../../../pizza/fields/PizzaContainer';

const BaseButton = styled(Button).attrs({ variant: 'light' })(
  css({
    height: [30, 30, 48],
    padding: 0,
    bg: '#fff',
    fontSize: [15, 15, 20],
    fontWeight: 'bold',
  })
);

const HintButton = styled(BaseButton)(
  css({
    width: [104, 104, 216],
  })
);

const PizzaButtonContainer = styled(Box)(
  css({
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-end',
    width: [172, 172, 276],
  })
);

const PizzaRealButton = styled(BaseButton)(
  css({
    pl: [48, 48, 80],
    pr: [15, 15, 24],
  })
);

const PizzaBox = styled(Box)(
  css({
    position: 'absolute',
    top: [(30 - 40) / 2, (30 - 40) / 2, (48 - 80) / 2].map(x => x + 'px'),
    left: 0,
    display: 'flex',
    width: [77, 77, 138],
    height: [40, 40, 80],
    pointerEvents: 'none',

    '&&& .pizza-container': {
      top: 0,
      left: 0,
      right: 0,
      height: '100%',
      width: '100%',
    },
  })
);

type PizzaButtonProps = {
  pizza: Pizza,
  children: React.Node,
  onClick?: Function,
};

function PizzaButton(props: PizzaButtonProps) {
  let { pizza, children, onClick, ...rest } = props;

  return (
    <PizzaButtonContainer {...rest}>
      <PizzaBox>
        <AutoScaleContainer preferedHeight={600} preferedMinHeight={600} preferedWidth={1080} preferedMinWidth={1080}>
          <PizzaContainer pizza={pizza} />
        </AutoScaleContainer>
      </PizzaBox>
      <PizzaRealButton onClick={onClick}>{children}</PizzaRealButton>
    </PizzaButtonContainer>
  );
}

export { HintButton, PizzaButton };
